import React, {Component} from "react";
import HDBFYPTreeTable from "./tree-table-data/HDBFYPTreeTable";
import {handleDayChange, renderSearchForm, search, searchData} from "./tree-table-data/utils/ReportUtils";
import {Table} from "reactstrap";
import HDBFYPHeader from "./tree-table-data/header/HDBFYPHeader";
import Loading from "../Loading";

class HDBReportFYP extends Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            treeValues: [],
            errorMessage: '',
            inputDay: '',
            selectedDay: undefined,
            isEmpty: true,
            isDisabled: false,
            apiSummary: '/api/bankportal/report/summary/fyp/hdb/directsale',
        }
        this.handleDayChange = handleDayChange.bind(this);
        this.search = search.bind(this);
        this.searchData = searchData.bind(this);
        this.renderSearchForm = renderSearchForm.bind(this);
        this.handlerSetIsLoading = this.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {
        let today = new Date();
        let yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        this.setState({
            selectedDay: yesterday,
            isEmpty: false,
            isValidDay: true,
            isLoading: true,
        });
        this.searchData(yesterday);
    }

    handlerSetIsLoading = (isLoading) =>{
        this.setState({isLoading: isLoading})
    }

    render() {
        const { isLoading, errorMessage,treeValues,selectedDay, inputDay } = this.state;
        return (
            <div className='report mx-0'>
                { isLoading && <Loading /> }
                <div className='mt-3'>
                    <h3 className='text-primary ml-5'>BÁO CÁO PHÍ BẢO HIỂM NĂM NHẤT ĐÃ THU - HDBank</h3>
                </div>
                { this.renderSearchForm(selectedDay) }
                <div className='m-2 bp-report-middle'>
                    <div>
                        <Table striped bordered hover size={"sm"} className={"table bp-report-table-80"}>
                            <HDBFYPHeader inputDay={inputDay}/>
                            <tbody>
                            <HDBFYPTreeTable node={treeValues[0]} marginLeft={0} handlerSetIsLoading={this.handlerSetIsLoading} />
                            </tbody>
                        </Table>
                    </div>
                    { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                </div>
            </div>
        );
    }
}
export default HDBReportFYP;